
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 bg-[#212026]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Let's Create Your Next Project with Precision
          </h2>
          <p className="text-xl text-[#dbcfbf] mb-8 max-w-3xl mx-auto">
            Ready to experience the difference that professional engineering and design expertise can make?
            Let's discuss your project requirements and deliver solutions that exceed your expectations.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <a href='/contact'><Button variant="outline" size="lg" className="border-[#dbcfbf] text-[#dbcfbf] hover:bg-[#dbcfbf] hover:text-[#212026]">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-phone-line"></i>
              </div>
              Contact Us
            </Button></a>
          </div>

          {/* Contact Info */}
          {/* <div className="mt-12 pt-8 border-t border-[#dbcfbf]/20">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <div className="w-12 h-12 bg-[#e18033] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                </div>
                <div className="text-[#dbcfbf] text-sm">Call Us</div>
                <div className="text-white font-medium">+1 (555) 123-4567</div>
              </div>
              <div>
                <div className="w-12 h-12 bg-[#e18033] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                </div>
                <div className="text-[#dbcfbf] text-sm">Email Us</div>
                <div className="text-white font-medium">info@DMI.com</div>
              </div>
              <div>
                <div className="w-12 h-12 bg-[#e18033] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                </div>
                <div className="text-[#dbcfbf] text-sm">Business Hours</div>
                <div className="text-white font-medium">Mon-Fri 8AM-6PM</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
